import { View } from "@/components/organisms/Table/enums";

export const defaultHeaders = [
  {
    text: "Наименование",
    sortable: true,
    key: "name",
  },
  {
    text: "Артикул",
    sortable: true,
    key: "sku",
  },
  {
    text: "Цена",
    sortable: true,
    key: "price",
  },
  {
    text: "Сумма",
    sortable: true,
    key: "total_price",
  },
  {
    text: "Вид: ",
    sortable: false,
    key: "action",
    items: [
      {
        title: "таблица",
        type: View.table,
      },
      {
        title: "список",
        type: View.list,
      },
    ],
  },
];

export const orderSelectHeader = {
  text: "Выбрать все",
  key: "select",
  sortable: false,
};
